/* eslint-disable no-param-reassign */
import { PayloadAction, createAction, createSlice } from '@reduxjs/toolkit';
import { PaymentState } from '../types/PaymentState';

const initialState: PaymentState = {
  deletingPayment: false,
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    isDeletingPayment(state, action: PayloadAction<boolean>) {
      state.deletingPayment = action.payload;
    },
  },
});

export const { isDeletingPayment } = paymentSlice.actions;

export const deletePayment = createAction<{
  clientId: string;
  hash: string;
  context: string;
}>('payment/deletePayment');
